import { Component, OnInit, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
  MatDialogModule,
} from '@angular/material/dialog';
import { IWProductSearchComponent } from '../product-search/product-search.component';
import { NgxLoadingModule } from 'ngx-loading';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-generate-alternatives-dialog',
  templateUrl: './generate-alternatives-dialog.component.html',
  styleUrls: ['./generate-alternatives-dialog.component.scss'],
  imports: [
    IWProductSearchComponent,
    NgxLoadingModule,
    MatDialogModule,
    MatButtonModule,
  ],
})
export class GenerateAlternativesDialogComponent implements OnInit {
  dialog = inject(MatDialog);
  dialogRef =
    inject<MatDialogRef<GenerateAlternativesDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  loading = false;
  fundData: any;
  modalMode = true;

  ngOnInit() {
    this.fundData = this.data;
  }

  cancel() {
    this.dialogRef.close('cancel');
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }
}
